module.exports = __webpack_public_path__ + "img/project_yyyy_2.bd5b26dd.png";